import { render } from "./ApplicantTest.vue?vue&type=template&id=f3a8beba&scoped=true"
import script from "./ApplicantTest.vue?vue&type=script&lang=ts"
export * from "./ApplicantTest.vue?vue&type=script&lang=ts"

import "./ApplicantTest.vue?vue&type=style&index=0&id=f3a8beba&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-f3a8beba"
/* custom blocks */
import block0 from "./ApplicantTest.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script